import { LegalStatementsModal } from '../ui';
import { useModalStore } from '@/shared/lib';

type Params = {
  onBack: () => void;
};

export function useLegalStatementsModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openLegalStatementsModal = ({ onBack }: Params) => {
    showDialogComponent({
      component: <LegalStatementsModal onBack={onBack} />,
      className: 'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openLegalStatementsModal };
}
